import { EmailArtifactLocation } from '@amazon-connect/email';
import { EmailAttachment } from '../models/Email';
import { fetchAttachment } from './fetchAttachment';

export const resolveEmailAttachments = async (
  attachmentLocations: EmailArtifactLocation[] | undefined,
  contactId: string
): Promise<EmailAttachment[]> => {
  const attachmentResults = await Promise.allSettled(
    (attachmentLocations ?? []).map(async (location): Promise<EmailAttachment> => {
      const { fileName, contentType } = await fetchAttachment(location.fileId, contactId);

      return {
        fileName,
        contentType,
        fileId: location.fileId,
        associatedResourceArn: location.associatedResourceArn
      };
    })
  );

  return attachmentResults
    .filter((result): result is PromiseFulfilledResult<EmailAttachment> => result.status === 'fulfilled')
    .map(result => result.value);
};
